// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__oIWl1","reviews__row":"styles_reviews__row__VJ2RX"};